import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlComfoair350 } from "./types";
import { useTranslation } from "react-i18next";

export const Levels = [0, 1, 2, 3];
export const Icons = Levels.map((level) => "fan-" + level);

interface IControlComfoair350Props {
  control: IControlComfoair350;
}

const ControlComfoair350 = (props: IControlComfoair350Props) => {
  const { control } = props;
  const fan = useControlAttribute(control, "fan");
  const tempOutside = useControlAttribute(control, "temp_outside");
  const tempSupply = useControlAttribute(control, "temp_supply");
  const mode: TMode = fan === 0 ? "off" : "on";
  const iconColor = useModeColor(mode);
  const { t } = useTranslation();

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={t("FROM to TO", {
        from: `${(tempOutside || 0).toFixed(1)}°C`,
        to: `${(tempSupply || 0).toFixed(1)}°C`,
      })}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name={Icons[fan]}
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlComfoair350;
